export const Italian = {
  translation: {
    pickup: {
      expiredTitle: "Il tuo link è scaduto",
      expiredDescriptionWithDays:
        "Sono trascorsi {{days}} giorni dall’invio del link, quindi dovrai ricominciare l’iscrizione. In questo modo potremo fornirti le informazioni più accurate per la tua situazione.",
      expiredDescription:
        "Questo link non è più valido. Ricomincia l’iscrizione per consentirci di fornirti le informazioni più accurate per la tua situazione.",
      newexpireDescription:
        "Dovrai ricominciare il processo di iscrizione per consentirci di fornirti le informazioni più accurate.",
      restart: "Ricomincia l’iscrizione",
      welcomeBack: "Bentornato, {{name}}",
      progressSaved:
        "Hai già completato una parte dell’iscrizione. Ora continuerai con:",
      fewMoreMinutes: "Dovrebbero bastare ancora pochi minuti.",
      continue: "Continua l’iscrizione",
      scheduledExistingAccount:
        "L’appuntamento per l’installazione è già programmato. Accedi a Il mio account per visualizzarlo e gestirlo.",
      scheduledNewAccount:
        "L’appuntamento per l’installazione è già programmato. Crea la password di Il mio account per visualizzarlo e gestirlo.",
      logInToAccount: "Accedi all’account",
      createAccount: "Crea account",
    },
    policies: {
      language: "Lingua",
      termsofUseLabel: "Termini di utilizzo",
      privacyLabel: "Privacy",
      cookiesLabel: "Cookie",
      qualityLabel: "Qualità",
      copyrightLabel: "Diritto d'autore",
    },
    navigation: {
      returnTo: "Torna a",
      lifesafer: "Lifesafer.com",
      lifesaferisa: "Lifesaferisa.com",
      assistMessage:
        "Il nostro esperto team di assistenza è a tua disposizione durante l’iscrizione",
    },
    europe: {
      welcomeTitle: "Benvenuto in LifeSafer",
      welcomeDescription:
        "Dispositivi Alcol Interlock conformi e sicuri, progettati per consentirti di tornare alla guida.",
      "GDPR-compliant": "Conformi alla normativa GDPR",
      Securebydesign: "Progettato con i più alti standard di sicurezza",
      Discreetandeasytouse: "Facile da usare e discreto",
      duration:
        "Questo processo richiede circa 5 minuti per essere completato.",
      getStarted: "Inizia",
      aboutYouTitle: "Informazioni Personali",
      aboutYouDescription:
        "Questi dati ci aiutano a verificare se possiamo soddisfare le tue esigenze e a personalizzare le informazioni che condivideremo con te. Non invieremo mai messaggi indesiderati né condivideremo i tuoi dati. La tua privacy è per noi molto importante!",
      violationCountry: "Paese della violazione",
      chooseCountry: "Scegli il paese…",
      countryRequired: "Il paese è obbligatorio",
      registrationCountryRequired: "La nazione di registrazione è obbligatoria",
      registrationNumberRequired: "Il numero di registrazione è obbligatorio",
      completeRequiredFields:
        "Completa tutti i campi obbligatori prima di continuare.",
      fieldRequired: "{{field}} è obbligatorio",
      privacyPolicy: "Informativa sulla privacy",
      vehicleTitle: "Informazioni sul Veicolo",
      whatFeatures: "Caratteristiche",
      vehicleRegistration: "Immatricolazione del veicolo",
      registrationCountry: "Nazione",
      selectRegistrationCountry: "Seleziona un paese",
      registrationNumber: "Targa",
      enterRegistrationNumber: "Inserisci il numero di matrícula",
      licensePlate: "Targa",
      licensePlateRequired: "La targa è obbligatoria",
      addressTitle: "Indirizzo di casa",
      postalCode: "Codice Postale",
      postalCodeRequired: "Il codice postale è obbligatorio",
      postalCodeInvalid: "Il codice postale è invalido",
      scheduleTitle: "Prenota il tuo appuntamento",
      scheduleDescription:
        "Sei pronto a fissare un appuntamento? Chiama il numero qui sotto e un membro del nostro team ti aiuterà a trovare l’officina e l’orario più adatti a te.",
      callToSchedule: "Chiama per prenotare",
      contactConsentMessage:
        "Utilizzeremo le informazioni fornite in questo modulo per rispondere alla tua richiesta e comunicare con te. Inviando questo modulo, riconosci che i tuoi dati saranno trattati in conformità con la nostra <privacyPolicy>Informativa sulla privacy</privacyPolicy>.",
    },
    quickLink: {
      firstName: "Nome",
      lastName: "Cognome",
      firstNameError: "Il nome è obbligatorio",
      cellPhoneError: "Inserisci un numero di telefono valido",
    },
    intro: {
      firstNameInvalid: "Inserisci un nome valido",
      lastNameRequired: "Il cognome è obbligatorio",
      lastNameError: "Inserisci un cognome valido",
      emailLabel: "Posta elettronica.",
      emailAddressRequired: "L’email è obbligatoria",
      emailAddressError: "Inserisci un indirizzo email valido",
    },
    error: {
      pickBackUpTokenError: [
        "Errore durante la convalida del token. Il token è scaduto o non è valido.",
        "Contatta il tuo fornitore di servizi.",
      ],
      botMessagePart1:
        "Beh, questa è imbarazzante! Pensiamo che potresti essere un bot proprio come me!?!",
      botMessagePart2:
        "Contattiamo il nostro team di supporto specializzato per aiutarti!",
      botCallUsButton: "Chiamaci",
      botStartOverButton: "Ricomincia",
      chatMessage:
        "Beh, è davvero imbarazzante! Sembra che qualcosa sia andato storto durante la connessione. Come possiamo aiutarti?",
      honeyPotError:
        "Si è verificato un errore. Contattaci per ricevere assistenza.",
      noCountyConfigured: "Nessuna contea è configurata per",
    },
    body: {
      country: "Nazione",
      city: "Città",
      province: "Provincia",
      homeAddr1Label: "Indirizzo",
      homeAddr2Label: "Indirizzo (riga 2)",
      enterHomeAddress: "Inserisci l’indirizzo",
      homeAddrRequired: "L’indirizzo è obbligatorio",
      zipRequired: "Il codice postale è obbligatorio",
      vehYearLabel: "Anno",
      selectVehYearLabel: "Seleziona un anno del veicolo",
      selectEngineTypeLabel: "Seleziona un tipo di motore",
      vehYearPlaceholder: "Seleziona un anno",
      vehYearRequired: "L’anno è obbligatorio",
      vehMakeLabel: "Marca",
      vehMakePlaceholder: "Scegli la marca",
      vehMakeRequired: "La marca è obbligatoria",
      vehModelLabel: "Modello",
      vehModelPlaceholder: "Scegli il modello",
      vehModelRequired: "Il modello è obbligatorio",
    },
    payments: {
      zipCode: "Codice postale",
    },
    steps: {
      continue: "Continua",
      vehiclePresentMessage:
        "Abbiamo trovato un veicolo precedentemente inserito nel nostro sistema. Quale desideri utilizzare?",
      back: "Indietro",
      saving: "Salvataggio",
      cellNumber: "Telefono",
      emailPlaceholder: "yourname@youremail.com",
      preferContacted: "Come preferisci essere contattato?",
      phoneCall: "Telefono",
      textMessage: "SMS",
      contactConsentMessage:
        "Utilizzeremo le informazioni fornite in questo modulo per rispondere alla tua richiesta e comunicare con te. Inviando questo modulo, riconosci che i tuoi dati saranno trattati in conformità con la nostra Informativa sulla privacy.",
      addressRequired: "{{addressRequired}}",
      engType: "Motore",
      engTypeRequired: "Il tipo di motore è obbligatorio",
      pushStartLevel: "Pulsante di avviamento",
      pushStartMessage:
        "Seleziona se il veicolo dispone di avviamento a pulsante.",
      remoteStart: "Avviamento da remoto",
      remoteStartMessage:
        "Seleziona se il veicolo dispone di avviamento da remoto.",
      select: "Seleziona",
      newVehicle: "Nuovo veicolo",
      vehicleInfo: "Informazioni sul veicolo",
    },
    location: {
      trimLevel: "Allestimento",
      trimLevelPlaceholder: "Scegli l’allestimento",
      trimLevelRequired: "L’allestimento è obbligatorio",
      whatFeatures: "Caratteristiche",
    },
    toasts: {
      updateFailed: "Aggiornamento non riuscito.",
    },
  },
};
